document.addEventListener('click', function(e) {
  const thumb = e.target.closest('.thumbnail');
  if (!thumb) return;

  const listItem = thumb.closest('li[data-target]');
  if (!listItem) return;

  const mediaId = listItem.getAttribute('data-target');
  const gallery = document.querySelector('media-gallery');

  if (gallery && typeof gallery.setActiveMedia === 'function') {
    // On remet true pour forcer l'affichage
    gallery.setActiveMedia(mediaId, true);
    
    // Petite astuce pour stabiliser après le changement
    setTimeout(() => {
      const activeSlide = document.getElementById(`Slide-${mediaId}`);
      if (activeSlide) {
        activeSlide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }, 50);
  }
});